import { render } from "./columns.vue?vue&type=template&id=3de1a98e&scoped=true"
import script from "./columns.vue?vue&type=script&lang=js"
export * from "./columns.vue?vue&type=script&lang=js"

import "../less/columns.less?vue&type=style&index=0&id=3de1a98e&scoped=true&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3de1a98e"]])

export default __exports__